import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Company } from '@core/models/company';
import { User } from '@core/models/user';
import { CompanyService } from '@core/services/company.service';
import { LoggingService } from '@core/services/logging.service';
import { UserService } from '@core/services/user.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrl: './invite.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
/**
 * InviteComponent
 *
 * Registration-step page that lets a user send company invites.
 * Multi-tenant safe: resolves company via `currentCompanyId` with legacy fallback.
 */
export class InviteComponent {
  private companyService = inject(CompanyService);
  private userService = inject(UserService);
  private loggingService = inject(LoggingService);

  user?: User | any;
  company?: Company;

  constructor() {
    this.getCompanyInformation();
  }

  getCompanyInformation() {
    this.userService
      .getUserModel()
      .pipe(take(1))
      .subscribe((user: User | null) => {
        if (user) {
          this.user = user;
          const currentCompanyId = user.currentCompanyId;
          if (!currentCompanyId) {
            this.loggingService.logError(
              'InviteComponent: user has no currentCompanyId/currentCompanyId',
              user,
            );
            return;
          }

          this.companyService
            .getDocument(currentCompanyId)
            .then((company: Company) => {
              this.company = company;
            })
            .catch((error: any) => {
              this.loggingService.logError(
                'InviteComponent: error fetching company information',
                error,
              );
            });
        }
      });
  }
}
